<div class="Modal">
  <div mat-dialog-actions class="container-modal-header">
    <div class="icon-warning">
        <span class="material-icons me-10">
            {{data.icon}}
        </span>
        <p class="m-0 p-0">{{data.textIcon}}</p>
    </div>
    <span class="material-icons icon-close" mat-button [mat-dialog-close]="true" cdkFocusInitial>
        close
    </span>
  </div>
  
  <div class="ModalContent">
    <div class="row">
      <div class="col">
        <h1 mat-dialog-title class="TtlModal">{{data.title}}</h1>
        <p class="TxtModal">{{data.text}}</p>
      </div>
    </div>
  </div>

  <div class="ModalFooter">
    <div class="align-items-center boxBtns d-flex justify-content-center">
      <button class="align-items-center Btn BtnPadrao" mat-button [mat-dialog-close]="true" (click)="onContinueClick()">
        {{data.textBtnOne}}
        <span class="material-icons align-middle">
          {{data.btnOneIcon}}
        </span>
      </button>
    </div>
  </div>

  <div class="ModalFooter">
    <a [routerLink]="data.routerContentLink" routerLinkActive="router-link-active">{{data.textLink}}</a>
    <p class="text-center TxtModal">{{data.textExtra}}</p>
  </div>

  <div class="ModalContact">
    <div class="boxBtnContact align-items-center justify-content-center text-center">
      <app-btn-whatsapp-border></app-btn-whatsapp-border>
  
      <app-sac-contact-link></app-sac-contact-link>
    </div>
  </div>

  <div class="ModalContent">
    <div class="d-md-block d-lg-block d-sm-none d-xs-none align-items-center justify-content-center">
      <app-btn-sac></app-btn-sac>
    </div>
  </div>
</div>